import { IHexGridData } from 'js/bubbleCore/types';
import { colRowToHash } from 'js/bubbleCore/utils/hash';

export function getGridValue<T>(grid: IHexGridData<T>, col: number, row: number): T | null {
  return grid.values[colRowToHash(col, row)] || null;
}